import { icons } from "assets/AssetHelper";
import dayjs from "dayjs";

export const detailsData = (t, { data }) => [
  {
    head: t("gift_cards.details"),
    icon: icons?.details,
    details: [
      {
        label: "City name(EN)",
        name: data?.localized_data?.en?.name,
      },
      {
        label: "City name(AR)",
        name: data?.localized_data?.ar?.name,
      },
      {
        label: t("cities.fulfillment_center"),
        name: data?.fulfillment_center?.name,
      },
    ],
  },
  {
    head: t("cities.fees"),
    icon: icons?.fees,
    details: [
      {
        label: t("cities.delivery_fees"),
        name: `${data?.delivery_fees} SAR`,
      },
    ],
  },
  {
    head: t("cities.map_details"),
    icon: icons?.map,
    details: [
      {
        label: t("cities.lat"),
        name: data?.lat,
      },
      {
        label: t("cities.long"),
        name: data?.long,
      },
    ],
  },
  {
    head: t("gift_cards.dates"),
    icon: icons?.dates,
    details: [
      {
        label: t("gift_cards.created_at"),
        name: dayjs(data?.created_at).format("DD-MM-YYYY HH:MM a"),
      },
      {
        label: t("gift_cards.updated_at"),
        name: dayjs(data?.updated_at).format("DD-MM-YYYY HH:MM a"),
      },
    ],
  },
];
